// extracted by mini-css-extract-plugin
export var conintestazione = "TabellaContenuti-module--conintestazione--604ef";
export var table = "TabellaContenuti-module--table--4e1dd";